export function scrollToHash(hash) {
  const el = document.getElementById(String(hash).replace(/^#/, ""));
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96, duration: 1.1 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollToTop(immediate = true) {
  if (window.__lenis) window.__lenis.scrollTo(0, { immediate });
  else window.scrollTo(0, 0);
}
